export default __webpack_public_path__ + "static/media/logo.e7860257.png";